import React, { useEffect, useState } from "react";
import styled, { css } from "react-emotion";
import * as styles from "../newStyles.styles";
import Footer from "../Footer";
import Header from "../Header";
import { getMailChimpCampaign, getMailChimpContentById } from "apis";
import FAQContainer from "../ComponentUtils/FAQContainer";
import { MailChimpForm } from "components";

const body = css`
  * {
    *,
    *:before,
    *:after {
      box-sizing: inherit;
    }
  }
  height: 100%;
  margin: 0;
  padding-top: 0.1px;
`;
// classes
const wrapper = css`
  width: 100%;
  margin: 0 auto;
  float: none;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const col = css`
  flex: 0 0 92%;
  margin: auto 4%;
  @media only screen and (min-width: 480px) {
    margin-left: 4%;
    margin-right: 0%;
    text-align: center;
  }
`;

const offwhite = css`
  background-color: #f6fbfb;
`;

const col1 = css`
  text-align: center;
`;

const contactImage = css`
  width: 375px;
  @media only screen and (min-width: 768px) {
    width: 400px;
  }
  @media only screen and (min-width: 900px) {
    width: 480px;
  }
  @media only screen and (min-width: 1200px) {
    width: 670px;
  }
`;
const H1 = styled("h1")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 22px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
`;

const P = styled("p")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
`;

function Newsletters({ history }) {
  const [campaigns, setCampaigns] = useState(null);

  const subscribed = localStorage.getItem(`chimpSub`);

  const getCampaigns = async () => {
    try {
      const result = await getMailChimpCampaign();
      result.sort(function (a, b) {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });

      var campaignsObject = {};
      result.forEach((campaign) => {
        var campaignDate = new Date(campaign.createdAt);
        var options = { month: "short", year: "numeric" };
        var cDateString = new Intl.DateTimeFormat("en-US", options).format(
          campaignDate
        );
        if (!campaignsObject[cDateString]) {
          campaignsObject[cDateString] = [campaign];
        } else {
          campaignsObject[cDateString].push(campaign);
        }
      });
      setCampaigns(campaignsObject);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getCampaigns();
  }, []);

  return (
    <div className={body}>
      <div className={wrapper}>
        <Header history={history} />
        <div className={styles.row}>
          <div className={styles.maxWidthWrapper}>
            <div className={col + " " + col1} style={{ textAlign: "right" }}>
              <styles.H2
                style={{
                  textAlign: "center",
                  margin: "30px 0px",
                  width: "100%",
                }}
              >
                Keep up with what we are working on!<br></br>{" "}
              </styles.H2>
            </div>

            {subscribed === "null" ? (
              <div
                className={styles.row}
                style={{
                  paddingTop: "35px",
                  margin: "auto",
                }}
              >
                <div className={styles.col} style={{ padding: "0px" }}>
                  <MailChimpForm />
                </div>
              </div>
            ) : null}
            <div className={styles.row}>
              <div className={styles.col}>
                {campaigns &&
                  Object.keys(campaigns).map((month) => {
                    return (
                      <FAQContainer
                        title={month}
                        campaigns={campaigns[month]}
                        key={month}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default Newsletters;
